<template>
  <div v-if="visible" class="mask admin-sys-mask" @click.self="onCancel">
    <div class="dialog dialog--shell dialog--narrow admin-sys-dialog" role="alertdialog" aria-modal="true">
      <div class="dialog-head">
        <h3 class="dialog-title">{{ title }}</h3>
        <button type="button" class="dialog-close" aria-label="关闭" @click="onCancel">×</button>
      </div>
      <div class="dialog-body">
        <p v-if="message" class="admin-sys-msg">{{ message }}</p>
        <input
          v-if="mode === 'prompt'"
          ref="promptInput"
          v-model="promptValue"
          class="admin-sys-input"
          type="text"
          :placeholder="placeholder"
          @keydown.enter.prevent="onOk"
        />
      </div>
      <div class="dialog-foot">
        <button v-if="mode !== 'alert'" type="button" class="btn btn-cancel" @click="onCancel">
          {{ cancelText }}
        </button>
        <button type="button" class="btn btn-primary" @click="onOk">{{ okText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { registerAdminDialogHandler } from '@/utils/adminDialog'

export default {
  name: 'AdminSystemDialog',
  data() {
    return {
      visible: false,
      mode: 'alert',
      title: '提示',
      message: '',
      okText: '确定',
      cancelText: '取消',
      placeholder: '',
      promptValue: '',
      pendingResolve: null,
    }
  },
  mounted() {
    registerAdminDialogHandler((job) => this.openJob(job))
  },
  beforeUnmount() {
    registerAdminDialogHandler(null)
  },
  methods: {
    openJob(job) {
      if (!job) return
      const mode = job.mode === 'confirm' || job.mode === 'prompt' ? job.mode : 'alert'
      this.mode = mode
      this.title =
        job.title || (mode === 'confirm' ? '请确认' : mode === 'prompt' ? '请输入' : '提示')
      this.message = job.message || ''
      this.okText = job.okText || '确定'
      this.cancelText = job.cancelText || '取消'
      this.placeholder = job.placeholder || ''
      this.promptValue = job.defaultValue == null ? '' : String(job.defaultValue)
      this.pendingResolve = job.resolve
      this.visible = true
      if (mode === 'prompt') {
        this.$nextTick(() => {
          try {
            this.$refs.promptInput?.focus?.()
          } catch {
            /* ignore */
          }
        })
      }
    },
    finish(value) {
      const r = this.pendingResolve
      this.pendingResolve = null
      this.visible = false
      if (typeof r === 'function') r(value)
    },
    onOk() {
      if (this.mode === 'prompt') {
        this.finish(this.promptValue)
        return
      }
      this.finish(true)
    },
    onCancel() {
      this.finish(this.mode === 'prompt' ? null : false)
    },
  },
}
</script>

<style scoped>
.admin-sys-mask {
  z-index: 4000;
}
.admin-sys-dialog {
  max-width: min(440px, calc(100vw - 32px));
}
.admin-sys-msg {
  margin: 0 0 10px;
  white-space: pre-wrap;
  word-break: break-word;
  color: #344054;
  font-size: 14px;
  line-height: 1.55;
}
.admin-sys-input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  border: 1px solid #d0d7e2;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
}
</style>
